import React from "react";
import Modal from "react-modal";
import { Button } from "@material-ui/core";

import emailjs from "emailjs-com";

function WidgetOptionsModal({ openModal, setOpenModal }) {
	const sendEmail = (e) => {
		e.preventDefault();

		emailjs
			.sendForm(
				"service_9wfritj",
				"template_zjmkqfj",
				e.target,
				"user_bZBSTVay3YWE4S0dWGYcY"
			)
			.then(
				(result) => {
					console.log(result.text);
				},
				(error) => {
					console.log(error.text);
				}
			);

		setOpenModal(false);
	};

	return (
		<div>
			<Modal
				isOpen={openModal}
				onRequestClose={() => setOpenModal(false)}
				style={{
					overlay: {
						width: 700,
						height: 600,
						backgroundColor: "transparent",
						boxShadow:
							"box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
						zIndex: "1100",
						top: "50%",
						left: "50%",
						marginTop: "-300px",
						marginLeft: "-350px",
					},
				}}
			>
				<form onSubmit={sendEmail} className="form-grp">
					<h3>Drop us a line</h3>
					<div className="form-element">
						<label>Your name</label>
						<input
							type="text"
							name="name"
							placeholder="Please enter your name"
							required
						/>
					</div>
					<div className="form-element">
						<label>Email</label>
						<input
							type="text"
							name="email"
							placeholder="Please enter your email"
							required
						/>
					</div>
					<div className="form-element">
						<label>Subject</label>
						<select name="subject">
							<option>Suggest Project Space 🚀</option>
							<option>Tell us about the bugs 🐛</option>
							<option>Tell us about a great builder 👷🏽</option>
						</select>
					</div>
					<div className="form-element">
						<label>Message</label>
						<textarea
							type="text"
							name="message"
							placeholder="Enter your message here"
							rows="6"
							required
						></textarea>
					</div>
					<Button onClick={() => setOpenModal(false)}>Cancel</Button>
					<Button type="submit">Send</Button>
				</form>
			</Modal>
		</div>
	);
}

export default WidgetOptionsModal;
